const TableConstants = {
  ARTICLE_AUTHOR_PROPERTY: 'author',
  ARTICLE_NAME_PROPERTY: 'name',
  ASC_ORDER: 'ascending',
  CATEGORY_COL_WIDTH_EXTRA_LARGE_SCREEN: 250,
  CATEGORY_COL_WIDTH: 160,
  CATEGORY_PROPERTY: 'category',
  CHECKBOX_COL_WIDTH: 60,
  COUNT_PROPERTY: 'count',
  CREATED_AT_PROPERTY: 'created',
  DEFAULT_INIT_OFFSET: 0,
  DEFAULT_SEARCH: '',
  DESC_ORDER: 'descending',
  NUM_COLUMNS: 4,
  NUM_ROWS_PER_PAGE: 10,
  UPDATED_AT_PROPERTY: 'updated',
  UPDATED_COL_WIDTH_EXTRA_LARGE_SCREEN: 180,
  UPDATED_COL_WIDTH: 160,
  EMPTY_TABLE: 'manage.empty'
};
export default TableConstants;
export const DEFAULT_HEADERS = [TableConstants.ARTICLE_NAME_PROPERTY, TableConstants.RESPONSES_PROPERTY, TableConstants.CATEGORY_PROPERTY, TableConstants.UPDATED_AT_PROPERTY];
export const DEFAULT_ORDERS = [TableConstants.ASC_ORDER, TableConstants.DESC_ORDER];